// Match the same path segments as React Router. Similar page names, such as
// /leitlinien and /leitlinien-umfragen, require independent permissions.
export const ROUTE_PERMISSIONS = [
  ['/abstimmungen-analytics', 'abstimmungen-analytics'], ['/feedback', 'feedback'],
  ['/abstimmungen-alt', 'abstimmungen'], ['/abstimmungen', 'abstimmungen'], ['/abstimmung/', 'abstimmungen'],
  ['/konsultation', 'konsultation'], ['/abfragen', 'abfragen'], ['/abfrage/', 'abfragen'],
  ['/authors', 'authors'], ['/fragenvorlagen', 'fragenvorlagen'],
  ['/activity', 'activity'], ['/leitlinien', 'leitlinien'], ['/stageleitlinien', 'stageleitlinien'],
  ['/livearbeitsversionen', 'livearbeitsversionen'], ['/hub-analytics', 'hub-analytics'],
  ['/hub-leitlinien', 'hub-leitlinien'], ['/app-analytics', 'app-analytics'],
  ['/app-benachrichtigungen', 'app-benachrichtigungen'], ['/leitlinien-umfragen', 'leitlinien-umfragen'],
  ['/leitlinien-kommentare', 'leitlinien-kommentare'], ['/newsletter', 'newsletter'],
  ['/emailvorlagen', 'emailvorlagen'], ['/deepsearch', 'deepsearch'],
  ['/fachgesellschaftengraph', 'fachgesellschaftengraph'],
]


export function getRoutePermission(pathname) {
  if (typeof pathname !== 'string') return null
  const path = pathname.toLowerCase()
  const match = ROUTE_PERMISSIONS.find(([prefix]) => {
    const base = prefix.replace(/\/+$/, '')
    return path === base || path.startsWith(base + '/')
  })
  return match ? match[1] : null
}
